import { useNavigate } from "react-router-dom";
import BadReadsBrowser from "../BadReadsBrowser";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";

const ReadQuality = () => {
  const { caseId, lensId } = useParamNumbers(["caseId", "lensId"]);

  const navigate = useNavigate();

  if (lensId === undefined || caseId === undefined) {
    navigate("../");
    return null;
  }

  return <BadReadsBrowser lensId={lensId} caseId={caseId} />;
};

export default ReadQuality;
